import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { CustomerReview } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-customer-reviews',
    templateUrl: './customer-reviews.component.html',
    styleUrls: ['./customer-reviews.component.scss'],
    standalone: false,
})
export class CustomerReviewsComponent implements OnInit {
    appInfo = inject(AppInformationService);
    utility = inject(UtilityService);
    reviews: any;
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, public auth: AuthService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.reviews = (await this.uow.getCustomerReviews()) as CustomerReview[];
        this.utility.customerReviewCount.set((await this.utility.getCustomerReviewCount()) as any);
    }

    async rowPrepare(e) {
        if (e.rowType !== 'data') return;
        const review = e.data;
        if (review.acknowledged) {
            e.rowElement.className = e.rowElement.className + ' acknowledged';
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

  async  process() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData() as CustomerReview[];
        if (selectedRows.length === 0) return;

        const result = await confirm(`Are you sure you want to process the selected reviews?`, this.appInfo.settings.company);
        if (!result) return;

        await this.appInfo.pleaseWaitShow();
        await this.utility.processCustomerFeedback(selectedRows[0].id);

        await this.getData();
        this.dataGrid.instance.clearSelection();
        await this.appInfo.pleaseWaitHide();
    }

    async acknowledgeReview(review: CustomerReview) {
        if (!review) return;

        const result = await confirm(`Are you sure you want to mark the selected review as acknowledged?`, this.appInfo.settings.company);
        if (!result) return;

        await this.appInfo.pleaseWaitShow();
        review.acknowledged = true;
        review.acknowledgedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.dataGrid.instance.clearSelection();
        this.utility.customerReviewCount.set((await this.utility.getCustomerReviewCount()) as any);
        await this.appInfo.pleaseWaitHide();
    }

    async delete(review: CustomerReview) {
        if (!review) return;

        const result = await confirm(`Are you sure you want to delete the selected review?`, this.appInfo.settings.company);
        if (!result) return;

        await this.appInfo.pleaseWaitShow();
        review.deleted = new Date();
        review.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.dataGrid.instance.clearSelection();
        this.utility.customerReviewCount.set((await this.utility.getCustomerReviewCount()) as any);
        await this.appInfo.pleaseWaitHide();
    }
}
